import { List, Modal, Space } from 'antd'
import React, { useState } from 'react'
import { BookOutlined } from '@ant-design/icons'

function SoftCourseDesc(props) {
    const [open, setOpen] = useState(false)
    return (
        <>
            <List.Item key={props.bjcks_id} style={{ lineHeight: '36px' }}>
                <a onClick={() => setOpen(true)}>
                    <Space>
                        <BookOutlined /> {props.bjcks_name}
                    </Space>
                </a>
            </List.Item>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false)
                }}
                onOk={() => {}}
                footer={null}
                width="100%"
                style={{ top: 8, maxWidth: '100vw' }}
                styles={{ body: { maxHeight: '80vh', overflowY: 'auto' } }}
                title={props.bjcks_name}
            >
                <div dangerouslySetInnerHTML={{ __html: props.bjcks_content }} />
            </Modal>
        </>
    )
}

export default SoftCourseDesc
